import { atom } from 'jotai';

export const networkOrVisibilityTickAtom = atom<number>(0);
